// @ts-nocheck
import "./FilesInput.scss";

import { Component, h, render } from "preact";
import { useCallback, useState } from "preact/hooks";

import Spinner from "../Spinner/Spinner";
import { getCustomText } from "@/utils/getCustomText";
import { uploadFile } from "@/api";

const max = 6;

function FilesInput({ value = [], onChange = () => null }) {
  const [loading, setLoading] = useState(false);

  const handleSelectFiles = useCallback(
    async (e) => {
      let originalFiles = [...e.target.files];

      originalFiles.length = max - value.length;
      originalFiles = originalFiles.filter(Boolean);

      if (originalFiles.length === 0) return;

      setLoading(true);

      try {
        const fileObjects = await Promise.all(originalFiles.map(uploadFile));
        onChange([...value, ...fileObjects]);
      } catch (error) {
        console.error(error);
      }

      setLoading(false);
      e.target.value = "";
    },
    [value, onChange]
  );

  const handleDeleteFile = useCallback(
    (fileId) => {
      onChange(value.filter((file) => file.id !== fileId));
    },
    [value]
  );

  return (
    <div className="CCFilesInput">
      <label className="CCFilesInput__label t-text">
        {getCustomText("reviewFormFields.photosLabel")}
      </label>
      <div className="CCFilesInput__files">
        {max > value?.length && (
          <label className="CCFilesInput__add t-text">
            <input
              type="file"
              style={{ display: "none" }}
              onChange={handleSelectFiles}
              multiple
              accept="image/jpeg,image/png,image/jpg"
              max={max}
            />
          </label>
        )}

        {value.map((file) => (
          <div key={file.id} className="CCFilesInput__file">
            <button
              className="CCFilesInput__fileDelete"
              onClick={() => handleDeleteFile(file.id)}
            />
            <img src={file.url} />
          </div>
        ))}

        {loading && (
          <div className="CCFilesInput__loading">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
}

export default FilesInput;
